export const blockIconsHomeEnergySavingsLeaf = (
	<span className='material-symbols-outlined'>energy_savings_leaf</span>
);
